import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { useTheme } from 'styled-components';
import { useTranslations } from '../../../features/providers/translations-provider';
import Div from '../div';
import Typography from '../typography';
const SeeMoreLines = ({ text, lines, color, align = 'center', justify = 'center', }) => {
    const theme = useTheme();
    const [expanded, setExpanded] = useState(false);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const textRef = useRef(null);
    const { t } = useTranslations();
    useEffect(() => {
        const el = textRef.current;
        if (!el)
            return;
        setIsOverflowing(el.scrollHeight > el.clientHeight);
    }, [text, lines]);
    return (_jsxs(Div, { flex: "column", align: align, justify: justify, gap: 8, children: [_jsx("div", { ref: textRef, style: {
                    display: '-webkit-box',
                    WebkitLineClamp: expanded ? 'unset' : lines,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    whiteSpace: 'normal',
                    textOverflow: 'ellipsis',
                    color,
                }, children: text }), isOverflowing && (_jsx(Typography, { onClick: () => setExpanded(!expanded), elementTheme: "body2", color: theme.colors.purple_2, fitContent: true, style: {
                    cursor: 'pointer',
                    padding: 0,
                    borderBottom: '1px solid ' + theme.colors.purple_2,
                }, children: expanded ? t('button|showLess') : t('button|showMore') }))] }));
};
export default SeeMoreLines;
